export default __webpack_public_path__ + "static/media/background-full.f5b9438b.jpeg";